import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ConfigResponse, ViewMode } from '@magnetar/admin-api-interfaces'

interface UseConfigParams {
  viewMode?: ViewMode
  viewModeId?: number | null
}

export function useConfig(params: UseConfigParams = {}) {
  const { token } = useAuth()
  const { viewMode, viewModeId } = params

  const queryParams = new URLSearchParams()
  if (viewMode) {
    queryParams.append('viewMode', viewMode)
  }
  if (viewModeId) {
    queryParams.append('viewModeId', viewModeId.toString())
  }

  const queryString = queryParams.toString()
  const url = queryString ? `/api/config?${queryString}` : '/api/config'

  const { data, error, mutate, isLoading } = useGet<ConfigResponse>(
    token ? url : null,
    undefined,
    token ?? '',
  )

  return {
    config: data?.data,
    branding: data?.data?.branding,
    menu: data?.data?.menu,
    user: data?.data?.user,
    availableContexts: data?.data?.availableContexts,
    viewMode: data?.data?.viewMode,
    viewModeId: data?.data?.viewModeId,
    isLoading,
    isError: error,
    mutate,
  }
}
